
import { compressOptions } from '@/common/material-metadata';
export default {
  props: {
    formValue: {
      type: Object,
      required: true
    },
    materialSource: {
      type: Number
    },
    selectTasks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formConfig: {
        labelWidth: '150px'
      }
    };
  },

  computed: {
    isCanCompress: function isCanCompress() {
      if (!this.selectTasks.length) return false;
      // 只有自研素材才支持压缩
      if (this.materialSource !== 2) return false;
      // 只有categoryid 是1,2,3的时候才支持压缩
      var canCompress = [1, 2, 3];
      return canCompress.indexOf(this.selectTasks[0].category_id) !== -1;
    },
    formItem: function formItem() {
      var _this = this;

      return [{
        label: '是否压缩：',
        type: 'radio-group',
        prop: 'is_compress',
        params: function params() {
          return {
            disabled: !_this.isCanCompress,
            options: compressOptions.map(function (item) {
              item.border = true;
              return item;
            }),
            button: false,
            border: true
          };
        }
      }, {
        label: '请上传基础包：',
        type: 'business',
        subtype: 'single-file-uploader',
        prop: 'basic_file',
        rules: [{
          required: true,
          message: '请选择上传基础包',
          trigger: 'blur'
        }],
        params: {
          disabled: false,
          drag: true,
          'with-credentials': true,
          accept: 'application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream',
          tip: '只能上传zip文件',
          fileList: []
        }
      }, {
        label: '修改说明：',
        type: 'input',
        subtype: 'textarea',
        prop: 'comment',
        rules: [{
          required: true,
          message: '请输入修改说明',
          trigger: 'blur'
        }]
      }];
    }
  },

  watch: {
    isCanCompress: {
      handler: function handler(val) {
        if (!val) {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.is_compress = 2;
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.is_compress = 3;
        }
      },

      immediate: true
    }
  },

  methods: {
    validate: function validate() {
      return this.$refs['form'].validate();
    }
  }
};